export default __webpack_public_path__ + "static/media/sparck-appreciation-style.1b9b3f34.png";